import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './Tutorial.module.css';
import { TUTORIAL } from '../../constants/strings';
import sharedButtonStyles from '../button/Button.module.css';

export default function Tutorial({ onCancel }) {
  const [step, setStep] = useState(1);
  const svgDir = require.context('../../assets/images/tutorial/');

  const onNext = () => {
    if (step < TUTORIAL.length) {
      setStep((pre) => pre + 1);
    } else {
      onCancel();
    }
  };

  const onSkip = () => {
    setStep(1);
    onCancel();
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.title}>
        {`Step ${step} of ${TUTORIAL.length}`}
      </div>
      <img src={svgDir(`./tutorial${step}.svg`)} alt="" />
      <p className={styles.text}>{TUTORIAL[step - 1]}</p>
      <div className={styles.buttonContainer}>
        <button type="button" className={classNames(styles.skipButton, sharedButtonStyles.FCButton, sharedButtonStyles.short)} onClick={() => onSkip()}>Exit</button>
        <button type="button" className={classNames(styles.nextButton, sharedButtonStyles.FCButton, sharedButtonStyles.short)} onClick={() => onNext()}>Next</button>
      </div>
    </div>
  );
}
